import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@coolblue-development/freddy';
import { useTranslation } from '../../i18n/useTranslation.js';
import Dropdown from './Dropdown/Dropdown.js';
import SidePanel from './SidePanel/SidePanel.js';
const MyCoolblueMenu = ({ accountName, isCustomerRecognised, urls }) => {
    const { t } = useTranslation('account');
    const myCoolblueLinkTitle = accountName
        ? `${t('myCoolblueLoggedIn')} ${accountName}`
        : t('myCoolblue');
    const isCurrentRoute = (url) => !!urls.currentRoute && urls.currentRoute === url;
    const links = [
        {
            title: myCoolblueLinkTitle,
            url: urls.myCoolblue,
            trackingRedirect: 'My Coolblue',
            shouldBold: isCurrentRoute(urls.myCoolblue),
        },
        {
            title: t('ordersAndInvoices'),
            url: urls.ordersOverview,
            trackingRedirect: 'Orders',
            shouldBold: isCurrentRoute(urls.ordersOverview),
        },
        {
            title: t('returns'),
            url: urls.returns,
            trackingRedirect: 'Returns and repairs',
            shouldBold: isCurrentRoute(urls.returns),
        },
        {
            title: t('preference'),
            url: urls.informationAndPreferences,
            trackingRedirect: 'Information and preferences',
            shouldBold: isCurrentRoute(urls.informationAndPreferences),
        },
        {
            title: t('credit'),
            url: urls.credit,
            trackingRedirect: 'Credit',
            shouldBold: isCurrentRoute(urls.credit),
        },
        {
            title: t('discount'),
            url: urls.discounts,
            trackingRedirect: 'Discounts',
            shouldBold: isCurrentRoute(urls.discounts),
        },
        {
            title: t('wishlist'),
            url: urls.wishlist,
            trackingRedirect: 'Wishlist',
            shouldBold: isCurrentRoute(urls.wishlist),
        },
        {
            title: t('energy'),
            url: urls.coolblueEnergy,
            trackingRedirect: 'Coolblue Energy',
            shouldBold: isCurrentRoute(urls.coolblueEnergy),
        },
    ];
    if (isCustomerRecognised && urls.logout) {
        links.push({ title: t('logout'), url: urls.logout, isLogout: true });
    }
    return (_jsxs(_Fragment, { children: [_jsx(Box, { hideUntil: "md", children: _jsx(Dropdown, { accountName: accountName, isCustomerRecognised: isCustomerRecognised, links: links, loginUrl: urls.login }) }), _jsx(Box, { hideFrom: "md", children: _jsx(SidePanel, { title: accountName ? t('myCoolblue') : t('login'), links: links, isCustomerRecognised: isCustomerRecognised, loginUrl: urls.login }) })] }));
};
export default MyCoolblueMenu;
//# sourceMappingURL=MyCoolblueMenu.js.map